<template>
	<div>
    <div class="m_context">
		<el-row :gutter="20"  style="margin-bottom: 20px;">
			<el-col :span="5" style="margin-left:24px;">
	        	<el-select v-model="warnVl" @change="handleIconClick" placeholder="">
		          <el-option v-for="item in warnTypes" :key="item.vl" :label="item.label" :value="item.vl">
              </el-option>
		        </el-select>
			</el-col>
			<el-col :span="5" style="margin-left:0px;">
	        	<el-select v-model="dvVl" @change="handleIconClick" placeholder="">
		          <el-option v-for="item in dvTypes" :key="item.vl" :label="item.label" :value="item.vl">
              </el-option>
		        </el-select>
			</el-col>
			<el-col :span="5">
		        <el-input
              :placeholder="$t('app_terNo')"
	  			  icon="search"
	  			  v-model="queryVl"
	  			  :on-icon-click="handleIconClick"
	  			  @keyup.enter.native="focusEvent(handleIconClick)">
	  			</el-input>
	        </el-col>
		</el-row>

		<el-table :data="tableData2" @sort-change="sortChange" border class='tbPoint' @row-click='cellClick'>
			<el-table-column prop="terminalName" :label="$t('lin_global.label_name')">

			</el-table-column>
			<el-table-column prop="terminalNo" sortable="custom" :label="$t('lin_global.label_no')" width="">

			</el-table-column>

			<el-table-column prop="eventType" :formatter="formatStatus" :label="$t('lin_global.risk_type')" width="100">

			</el-table-column>
			<el-table-column prop="timeNow" sortable="custom" :label="$t('app_locktime')" width="170">
			</el-table-column>
			
			
			<el-table-column prop="status" :formatter="formatStatus1" :label="$t('lin_global.ter_status')" width="130">

			</el-table-column>

			<el-table-column :label="$t('app_operate')" width="130">
				<template slot-scope="scope">
					<el-tooltip class="item" effect="dark" :content="$t('lin_btn.unlock')" placement="top">
              <el-button type='text' ><i class="fa fa-unlock-alt" style="color:#FF4949"></i></el-button>
            </el-tooltip>
				</template>
			</el-table-column>

		</el-table>
		<div class="page_content" v-if="totalRecords > 0">
		  <el-pagination style='float:right;'
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    :current-page="currentPage"
		    :page-sizes="$gRows"
		    :page-size="$gRow"
		    layout="total, sizes, prev, pager, next, jumper"
		    :total="totalRecords">
		  </el-pagination>
		</div>
    </div>
	</div>
</template>
<script>
	import axios from 'axios'
	import {baseurl,focusEvent} from '../../api/url'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    components: {
      MechanismSelector
    },
		data(){
      var that = this
			return{
				orderName: '',
				orderType: '',
        mechanismData: {
          callback (value) {
            that.value1 = value
            that.statusChange(value)
          }
        },
				focusEvent: focusEvent,
		
				input1:'',
				value1: '',
				currentPage: 1,
				pageSize: 10,
				totalRecords: 0,
				tableData2:[],
				queryVl: '',
				warnVl: '',
				dvVl: '',
				warnTypes: [
					{vl:'', label: this.$t('app_alltyps')},
					{vl:'0', label: this.$t('app_bglock')},
					{vl:'1', label: this.$t('lin_global.ccwl')}
				],
				getWarnTypes: {
					'0': this.$t('app_bglock'),
					'1': this.$t('lin_global.ccwl')
				},
				getDvTypes: {
					
					'0': this.$t('app_request'),
					'1': this.$t('app_unrequest'),
					'2': this.$t('app_unlocked'),
				},
				dvTypes: [
					{vl:'', label: this.$t('lin_global.all_status')},
					{vl:'0', label: this.$t('app_request')},
					{vl:'1', label: this.$t('app_unrequest')},
					{vl:'2', label: this.$t('app_unlocked')},
				]

			}
		},
		created(){
			this.getList()
//			this.getAd1();
		},
		methods:{
			sortChange (vl) {
        switch (vl.prop) {
          case 'terminalNo':
            this.orderName = '1'
            break
          case 'timeNow':
            this.orderName = '2'
            break
        }
        this.orderType = vl.order == 'descending'? 'desc':'asc'
        this.getList()
      },
			handleIconClick () {
				this.getList()
			},
			getList () {
        this.loading = 1
				var tNo = this.queryVl ? this.queryVl : ''
				var type = this.warnVl ? this.warnVl : ''
				var st = this.dvVl ? this.dvVl : ''
		
				this.$getWarnList(this.currentPage, this.$gRow, st, localStorage.mechanismId, tNo, type, this.orderName, this.orderType,  (res) => {
          // console.log(res)
          this.loading = 0
          if (res.status === 200) {
            this.totalRecords = res.total
            this.tableData2 = res.data
            // console.log('tbd', res.data)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          // error
        })
        
        
      },
			cellClick(row, ev, col) {
				var label = col.label
				if (!label) return
			
				this.$setWObj('warnDetail', row)
				this.$router.push({path:'/warnlist/unlock'})
				// to detail
				// var cf = {};
				// var name = "";
				// if (row.appStatus === "1" || row.appStatus === "2") {
				// 	cf.type = 2;
				// 	cf.isHistory = 1;
				// 	name = "menu.appManageSub.appDetail";
				// } else {
				// 	cf.type = 1;
				// 	name = "menu.appManageSub.appEdit";
				// }
				// cf.data = row;
				// this.$setWObj("editAppConfig", cf);
				// this.$router.push({ name: this.$t(name) });
				

			},
		
			handleSizeChange: function (val) {
					this.$gRows = val
					this.getList()
			},
			handleCurrentChange: function (val) {
				
					this.currentPage = val
					this.getList()
			},
			formatStatus:function(row,column){
				return this.getWarnTypes[row.eventType]
			},
			formatStatus1:function(row,column){
				return this.getDvTypes[row.status]
			},
			
		}
	}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// warn.vue?5e229763